<app-modal-header
  [title]="title"
  (onCloseClick)="onCloseClick.emit($event)"
  (onReturnClick)="onReturnClick.emit($event)"
  [showReturn]="showReturn"
  [hideClose]="hideClose"
  >
</app-modal-header>
<app-modal-body>
  <ng-content></ng-content>
</app-modal-body>
<app-modal-footer *ngIf="!hideFooter"
  [hideCancel]="hideCancel"
  [hideSave]="hideSave"
  [cancelDisabled]="cancelDisabled"
  [cancelLabel]="cancelLabel"
  (onCancelClick)="onCancelClick.emit($event)"
  [saveDisabled]="saveDisabled"
  [saveLabel]="saveLabel"
  (onSaveClick)="onSaveClick.emit($event)"
>
</app-modal-footer>
